type Properties = {
    required?: boolean;
};

const RequiredAsterisk = (props: Properties) => {
    return (
        <>{props.required && <span className="text-red required-asterisk">*</span>}</>
    );
};

export default RequiredAsterisk;